import type { CalculateChecksum } from '@/modules/upload'

type FileChecksumCallback = (error: Error | null, checksum: string) => void
type FileChecksumCreate = (file: File, callback: FileChecksumCallback) => void

export const calculateChecksumFactory =
  (calculate: FileChecksumCreate): CalculateChecksum =>
  (file) =>
    new Promise((resolve, reject) => {
      calculate(file, (error, checksum) => {
        if (error) {
          reject(error)
          return
        }

        resolve(checksum)
      })
    })
